/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Hide_CheckedInputs */

const en_shopping_hide_checked = /** @type {(inputs: Shopping_Hide_CheckedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide`)
};

const de_shopping_hide_checked = /** @type {(inputs: Shopping_Hide_CheckedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausblenden`)
};

/**
* | output |
* | --- |
* | "Hide" |
*
* @param {Shopping_Hide_CheckedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_hide_checked = /** @type {((inputs?: Shopping_Hide_CheckedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Hide_CheckedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_hide_checked(inputs)
	return en_shopping_hide_checked(inputs)
});